import {shallowRef} from 'vue';
import {defineStore} from 'pinia';

export const useDomainStore = defineStore('domain', () => {
    const domain = shallowRef(null);

    function setDomain(newDomain) {
        domain.value = newDomain;
    }

    return {
        domain,
        setDomain,
    };
});
